import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaBuilding, 
  FaBriefcase, 
  FaLaptopCode, 
  FaChartLine, 
  FaUsers,
  FaHandshake,
  FaArrowLeft,
  FaWhatsapp,
  FaCheckCircle,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaEuroSign,
  FaStar,
  FaTrophy,
  FaClock,
  FaGraduationCap,
  FaQuoteLeft,
  FaRocket,
  FaMedal,
  FaUserTie,
  FaGlobe,
  FaBook,
  FaAward,
  FaUniversity,
  FaRegBuilding,
  FaShieldAlt,
  FaSchool,
  FaChevronRight  // ← AJOUT MANQUANT
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './PartenariatsEntreprises.css';

const PartenariatsEntreprises = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const partenaires = [
    {
      id: 1,
      name: "Société Générale",
      sector: "Banque / Finance",
      location: "Paris",
      type: "Partenaire bancaire",
      rating: 4.8,
      reviews: 245,
      featured: true,
      icon: <FaUniversity />,
      color: "#e31837"
    },
    {
      id: 2,
      name: "StudaPart",
      sector: "Hébergement étudiant",
      location: "France",
      type: "Logement",
      rating: 4.7,
      reviews: 312,
      featured: true,
      icon: <FaBuilding />,
      color: "#2c3e50"
    },
    {
      id: 3,
      name: "Nexity",
      sector: "Immobilier / Promotion",
      location: "France",
      type: "Logement étudiant",
      rating: 4.6,
      reviews: 198,
      featured: false,
      icon: <FaRegBuilding />,
      color: "#004d73"
    },
    {
      id: 4,
      name: "Smart Garant",
      sector: "Garantie locative",
      location: "France",
      type: "Services",
      rating: 4.9,
      reviews: 167,
      featured: true,
      icon: <FaShieldAlt />,
      color: "#00a651"
    },
    {
      id: 5,
      name: "Studely",
      sector: "Accompagnement étudiant",
      location: "France",
      type: "Services",
      rating: 4.5,
      reviews: 234,
      featured: false,
      icon: <FaGraduationCap />,
      color: "#6c5ce7"
    },
    {
      id: 6,
      name: "Omnes Education",
      sector: "Enseignement supérieur",
      location: "France",
      type: "École / Université",
      rating: 4.7,
      reviews: 189,
      featured: true,
      icon: <FaSchool />,
      color: "#ff6b6b"
    }
  ];

  const steps = [
    {
      id: 1,
      title: "Analyse de profil",
      description: "Évaluation approfondie de vos compétences, expériences et objectifs professionnels",
      icon: <FaUsers />,
      details: "Bilan de compétences gratuit"
    },
    {
      id: 2,
      title: "Matching entreprises",
      description: "Sélection des opportunités correspondant parfaitement à votre profil",
      icon: <FaBuilding />,
      details: "Algorithme de matching exclusif"
    },
    {
      id: 3,
      title: "Préparation candidature",
      description: "Optimisation CV, lettre de motivation, préparation intensive aux entretiens",
      icon: <FaLaptopCode />,
      details: "Coaching personnalisé"
    },
    {
      id: 4,
      title: "Suivi et placement",
      description: "Accompagnement jusqu'à l'obtention de l'offre et suivi post-intégration",
      icon: <FaChartLine />,
      details: "Garantie de placement"
    }
  ];

  const benefits = [
    { icon: <FaBuilding />, title: "Accès exclusif à 35+ entreprises partenaires", desc: "Réseau privilégié de recruteurs" },
    { icon: <FaBriefcase />, title: "Offres de stage et alternance privilégiées", desc: "Opportunités en avant-première" },
    { icon: <FaUserTie />, title: "Coaching personnalisé pour les entretiens", desc: "Simulations avec des professionnels" },
    { icon: <FaBook />, title: "Ateliers CV et lettre de motivation", desc: "Formation à la candidature" },
    { icon: <FaUsers />, title: "Networking avec des professionnels", desc: "Événements exclusifs" },
    { icon: <FaRocket />, title: "Suivi post-placement garanti", desc: "Accompagnement jusqu'à la prise de poste" }
  ];

  const successStories = [
    {
      name: "Amina K.",
      school: "HEC Paris",
      company: "Société Générale",
      position: "Analyste Financier",
      story: "Grâce à ETEF, j'ai décroché un stage chez Société Générale qui s'est transformé en CDI. L'accompagnement a été exceptionnel du début à la fin.",
      rating: 5,
      city: "Paris"
    },
    {
      name: "Thomas L.",
      school: "CentraleSupélec",
      company: "Nexity",
      position: "Chef de Projet Immobilier",
      story: "Le matching avec Nexity était parfait. Je suis aujourd'hui en alternance et ravi de mon parcours. Les conseils pour les entretiens m'ont vraiment aidé.",
      rating: 5,
      city: "Lyon"
    },
    {
      name: "Sophie M.",
      school: "ESCP Business School",
      company: "Studely",
      position: "Responsable Accompagnement",
      story: "ETEF m'a accompagnée dans ma recherche de stage et m'a permis de décrocher une offre chez Studely. Un service professionnel et efficace !",
      rating: 5,
      city: "Paris"
    }
  ];

  const faqs = [
    {
      q: "Comment se déroule le processus de matching ?",
      a: "Nous analysons votre profil, vos compétences et vos aspirations professionnelles. Notre algorithme identifie les entreprises et offres les plus pertinentes. Vous recevez ensuite des recommandations personnalisées."
    },
    {
      q: "Les offres sont-elles exclusives ?",
      a: "Oui, grâce à nos partenariats privilégiés, nous avons accès à des offres non publiées ailleurs. Nos entreprises partenaires nous confient leurs besoins en priorité."
    },
    {
      q: "Proposez-vous une préparation aux entretiens ?",
      a: "Absolument ! Nous organisons des simulations d'entretiens avec des professionnels, des ateliers de coaching et des conseils personnalisés pour maximiser vos chances de réussite."
    },
    {
      q: "Quel est le taux de placement après l'accompagnement ?",
      a: "Notre taux de placement est de 92% dans les 3 mois suivant l'accompagnement. Nous suivons nos candidats jusqu'à l'obtention d'une offre satisfaisante."
    },
    {
      q: "Proposez-vous des services pour les étudiants internationaux ?",
      a: "Oui, nous accompagnons également les étudiants internationaux dans leur recherche d'opportunités en France. Nous les aidons sur les spécificités du marché français."
    },
    {
      q: "Quels sont les délais pour obtenir une offre ?",
      a: "Le délai moyen est de 2 à 3 mois entre le début de l'accompagnement et l'obtention d'une offre. Cela varie selon votre profil et vos critères de recherche."
    }
  ];

  const stats = [
    { value: "6+", label: "Partenaires exclusifs" },
    { value: "50+", label: "Opportunités par an" },
    { value: "92%", label: "Taux de placement" },
    { value: "98%", label: "Satisfaction clients" }
  ];

  const sectors = [
    "Banque & Finance",
    "Immobilier & Logement",
    "Garantie & Services",
    "Accompagnement Étudiant",
    "Enseignement Supérieur",
    "Conseil & Stratégie"
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="partenariat-service-page">
      <Header />
      
      {/* Hero Section */}
      <section className="partenariat-hero">
        <div className="partenariat-hero-bg">
          <div className="partenariat-hero-bg-gradient"></div>
          <div className="partenariat-hero-bg-particles"></div>
        </div>
        <div className="partenariat-hero-container">
          <div className="partenariat-hero-content">
            <div className="partenariat-badge">
              <FaTrophy /> Réseau d'excellence
            </div>
            <h1>Partenariats <span className="partenariat-gradient-text">Entreprises</span></h1>
            <p>Accédez aux meilleures opportunités professionnelles grâce à notre réseau d'entreprises partenaires. Lancez votre carrière avec les leaders de votre secteur.</p>
            <div className="partenariat-hero-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="partenariat-stat-item">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                  </div>
                  {index < stats.length - 1 && <div className="partenariat-stat-divider"></div>}
                </React.Fragment>
              ))}
            </div>
            <div className="partenariat-hero-buttons">
              <Link to="/contact" className="partenariat-btn-primary">Déposer ma candidature</Link>
              {/* <Link to="/contact" className="partenariat-btn-outline">Découvrir les partenaires</Link> */}
              <a href="https://wa.me/33695744027" className="partenariat-btn-whatsapp-hero">
                <FaWhatsapp /> Conseils personnalisés
              </a>
            </div>
          </div>
        </div>
        <div className="partenariat-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Sectors Section */}
      <section className="partenariat-sectors">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Secteurs d'activité</h2>
            <p>Des opportunités dans tous les domaines</p>
          </div>
          <div className="partenariat-sectors-grid">
            {sectors.map((sector, index) => (
              <div key={index} className="partenariat-sector-item">
                <FaBriefcase />
                <span>{sector}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Steps Section */}
      <section className="partenariat-process">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Notre accompagnement</h2>
            <p>Un parcours structuré en 4 étapes pour réussir votre insertion professionnelle</p>
          </div>
          <div className="partenariat-steps-grid">
            {steps.map((step) => (
              <div key={step.id} className="partenariat-step-card">
                <div className="partenariat-step-number">{step.id}</div>
                <div className="partenariat-step-icon">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <span className="partenariat-step-detail">{step.details}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partenaires Section */}
      <section className="partenariat-entreprises">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Nos partenaires exclusifs</h2>
            <p>Des leaders engagés pour votre réussite</p>
          </div>
          <div className="partenariat-entreprises-grid">
            {partenaires.map((partenaire) => (
              <div key={partenaire.id} className={`partenariat-entreprise-card ${partenaire.featured ? 'featured' : ''}`}>
                {partenaire.featured && (
                  <div className="partenariat-entreprise-badge">
                    <FaStar /> Partenaire premium
                  </div>
                )}
                <div className="partenariat-entreprise-icon" style={{ backgroundColor: `${partenaire.color}15`, color: partenaire.color }}>
                  {partenaire.icon}
                </div>
                <div className="partenariat-entreprise-header">
                  <h3>{partenaire.name}</h3>
                  <div className="partenariat-entreprise-rating">
                    <FaStar /> {partenaire.rating}
                    <span className="reviews">({partenaire.reviews})</span>
                  </div>
                </div>
                <p className="partenariat-entreprise-sector">{partenaire.sector}</p>
                <p className="partenariat-entreprise-location">
                  <FaMapMarkerAlt /> {partenaire.location}
                </p>
                <div className="partenariat-entreprise-type">
                  <span className="partenariat-type-tag">{partenaire.type}</span>
                </div>
                <Link to="/contact" className="partenariat-entreprise-link">
                  Découvrir les opportunités
                </Link>
              </div>
            ))}
          </div>
          <div className="partenariat-more-entreprises">
            <Link to="/contact" className="partenariat-link-more">
              Devenir partenaire →
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="partenariat-benefits">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Pourquoi choisir notre service ?</h2>
            <p>Des avantages exclusifs pour booster votre carrière</p>
          </div>
          <div className="partenariat-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="partenariat-benefit-item">
                <div className="partenariat-benefit-icon">{benefit.icon}</div>
                <div className="partenariat-benefit-content">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="partenariat-success">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Histoires de réussite</h2>
            <p>Des étudiants qui ont trouvé leur voie grâce à nos partenariats</p>
          </div>
          <div className="partenariat-success-grid">
            {successStories.map((story, index) => (
              <div key={index} className="partenariat-success-card">
                <FaQuoteLeft className="partenariat-quote-icon" />
                <p className="partenariat-success-text">"{story.story}"</p>
                <div className="partenariat-success-info">
                  <div>
                    <strong>{story.name}</strong>
                    <div className="partenariat-success-details">
                      <span><FaGraduationCap /> {story.school}</span>
                      <span className="dot">•</span>
                      <span><FaMapMarkerAlt /> {story.city}</span>
                    </div>
                  </div>
                  <div className="partenariat-success-company">
                    <FaBriefcase /> {story.company} - {story.position}
                  </div>
                </div>
                <div className="partenariat-success-rating">
                  {[...Array(story.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="partenariat-faq">
        <div className="partenariat-container">
          <div className="partenariat-section-header">
            <h2>Questions fréquentes</h2>
            <p>Tout ce que vous devez savoir sur nos services</p>
          </div>
          <div className="partenariat-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="partenariat-faq-item">
                <button className="partenariat-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`partenariat-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`partenariat-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="partenariat-cta">
        <div className="partenariat-container">
          <div className="partenariat-cta-wrapper">
            <div className="partenariat-cta-content">
              <h2>Prêt à lancer votre carrière ?</h2>
              <p>Bénéficiez d'un coaching personnalisé et accédez aux meilleures opportunités. Premier conseil gratuit !</p>
              <div className="partenariat-cta-buttons">
                <Link to="/contact" className="partenariat-btn-dark">Déposer mon CV</Link>
                <a href="https://wa.me/33695744027" className="partenariat-btn-whatsapp">
                  <FaWhatsapp /> Conseils personnalisés
                </a>
              </div>
              <div className="partenariat-cta-note">
                <FaRocket /> Gratuit et sans engagement
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PartenariatsEntreprises;